'use client'

import { useCallback } from 'react'

import { getClientAnalytics } from '../client-instance'
import type { AnalyticsUserProperties, BaseEventProperties } from '../types'

interface UseAnalyticsReturn {
  reset: () => void
  track: (eventName: string, properties?: BaseEventProperties) => void
  identify: (userId: string) => void
  setUserProperties: (properties: AnalyticsUserProperties) => void
}

export function useAnalytics(): UseAnalyticsReturn {
  const track = useCallback(
    (eventName: string, properties?: BaseEventProperties) => {
      getClientAnalytics().track(eventName, properties)
    },
    [],
  )

  const identify = useCallback((userId: string) => {
    getClientAnalytics().identify(userId)
  }, [])

  const setUserProperties = useCallback(
    (properties: AnalyticsUserProperties) => {
      getClientAnalytics().setUserProperties(properties)
    },
    [],
  )

  const reset = useCallback(() => {
    getClientAnalytics().reset()
  }, [])

  return { track, identify, setUserProperties, reset }
}
